import React from 'react';
import Skeleton from '@material-ui/lab/Skeleton';
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Box from '@material-ui/core/Box';
import { cardImageHeight, useStyles } from "./styles";
export function TourSearchResultCardSkeleton() {
    const classes = useStyles();
    return (React.createElement(Paper, { className: classes.root, classes: undefined, elevation: 2 },
        React.createElement("div", { className: classes.card },
            React.createElement("div", { className: classes.img },
                React.createElement(Skeleton, { variant: "rect", width: "100%", height: cardImageHeight })),
            React.createElement(Grid, { container: true, className: classes.cardMain, spacing: 3 },
                React.createElement(Grid, { item: true, xs: 12, md: 9 },
                    React.createElement(Box, { mb: 2 },
                        React.createElement(Skeleton, { animation: "wave", width: 200 }),
                        React.createElement(Skeleton, { animation: "wave", width: 400, height: 30 })),
                    React.createElement(Skeleton, { animation: "wave" }),
                    React.createElement(Skeleton, { animation: "wave" })),
                React.createElement(Grid, { item: true, xs: 12, md: 3 },
                    React.createElement(Skeleton, { animation: "wave", width: 150, height: 50 }))))));
}
